<template>
  <gj-modal
      size="1200_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
    >
    <template #header>操作日志</template>
    <template #content>
      <app-base-main no-padding parentTable :table-shadow="false">
        <template #filter-group>
          <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery" :isBr="clientWidth > 1366 ? false : true">
            <gj-date-picker
                    v-model="form.date"
                    :clearable="false"
                    type="daterange"
                    tooltip="数据时间"
                    :max-day-length="180"
                ></gj-date-picker>
            <gj-search-input
                v-model="form.name"
                width="180px"
                placeholder="请输入模板名称"
            ></gj-search-input>
           
          </app-filter-group>
        </template>
        <template #table >
            <gj-table
              ref="gjTable"
              :index="false"
              name="rule-log"
              :loading="loading"
              :adapt-height="false"
              :height="500"
              :data="tableData"
              :columns="columns"
              :show-overflow="false"
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery"
            >
            <template v-slot:sourceVo="{row}">
              <div style="display: flex; flex-wrap: nowrap; align-items: center; overflow: hidden;">
                <div style="float: left; width: 100%; maigin-right: -20px;">
                  <div v-if="row.sourceVo === null || row.sourceVo === ''">-</div>
                  <div v-else>
                    <p><span class="op-title">模板名称：</span> {{row.sourceVo.name | defaultShow}}</p>
                    <p><span class="op-title">执行结果通知：</span> {{optionMap[row.sourceVo.notifyType] | defaultShow}}</p>
                    <p><span class="op-title">通知人：</span> {{getNotifiInfo(row.sourceVo.notifyUser) }}</p>
                    <p >{{getOperationInfo(row.sourceVo)}}</p>
                    <!-- <p v-if="row.sourceVo.state"><span class="op-title">模板状态：</span> {{option.stateMap[row.sourceVo.state] | defaultShow}}</p> -->
                    </div>
                </div>
                <div style="float: right; width: 30px; height: 100%;">
                  <el-image
                    :src="require('@/assets/images/ad/ad-next-to.png')"
                    style="margin-left: 10px; width: 15px; height: 5px;"
                   ></el-image>
                </div>
              </div>
            </template>
             <template v-slot:targetVo="{row}">
                <div>
                  <div v-if="row.targetVo === null || row.targetVo === ''">-</div>
                  <div v-else>
                    <p><span class="op-title">模板名称：</span> {{row.targetVo.name | defaultShow}}</p>
                    <p><span class="op-title">执行结果通知：</span> {{optionMap[row.targetVo.notifyType] | defaultShow}}</p>
                    <p><span class="op-title">通知人：</span> {{getNotifiInfo(row.targetVo.notifyUser)}}</p>
                    <p >{{getOperationInfo(row.targetVo)}}</p>
                    <!-- <p v-if="row.targetVo.state"><span class="op-title">模板状态：</span> {{option.stateMap[row.targetVo.state] | defaultShow}}</p> -->
                    </div>
                </div>
            </template>
            </gj-table>
        </template>
       </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, isMeaningfulMixin, queryMixin,isMeaninglessMixin} from "@/minxins";
import {getRuleLogData, SP} from "@/api/ad";
import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
import {subDays} from 'date-fns';
import {convertToDate} from "@/utils/date.util";
import { getRuleContent, optionMap, option } from "../const";
export default {
  name: "ad-operation-log-modal",
  mixins: [modalMixIn, isMeaningfulMixin, queryMixin, isMeaninglessMixin],
  props: {
    ruleId: {
      required: true
    },
  },
  data() {
    return {
        optionMap,
        option,
        form: {
          name: '',
          date: [subDays(new Date(), 6), new Date()]
        },
        operatingTypeOption:[
          { id: 'create', text: '新增' },
          { id: 'update', text: '修改' },
          { id: 'delete', text: '删除' }
        ],
        columns: [
          { id: 'name',header: '模板名称',field: 'name',minWidth: '120px'},
          { id: 'operatingType', header: '操作类型', field: 'option:operatingType', minWidth: '100px', options:() => this.operatingTypeOption },
          { id: 'sourceVo', header: '操作前', field: 'slot:sourceVo', minWidth: '230px'},
          { id: 'targetVo', header: '操作后', field: 'slot:targetVo', minWidth: '200px' },
          { id: 'createUser', header: '操作用户', field: 'createUser', width: '100px'},
          { id: 'createTime', header: '操作时间', field: 'createTime', width: '180px'},
        ],
        tableData:[]
        
    }
  },
  methods: {
     $gjQueryInitParams() {
      return {
          form: {
            name: '',
            date: [subDays(new Date(), 6), new Date()]
        },
      };
    },
    $gjQuery() {
      // 构造查询参数
      const params = {
        model: {
          id: this.ruleId,
          name: this.form.name,
          startTime: convertToDate(this.form.date[0]),
          endTime: convertToDate(this.form.date[1]),
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      // 查询
      this.loading = true;
      getRuleLogData(params).then((data) => {
          if (isMeaningful(data)) {
            this.tableData = data.data.records;
            this.pagination = this.getPagination(data.data);
             
          } else {
            this.tableData = [];
          }
        }).complete(() => {
          this.loading = false;
        });
    },
    // 规则内容
    getOperationInfo(item) {
      if (isMeaningful(item.expressionVO)) {
         return getRuleContent(item.expressionVO);
      }else {
        return '-';
      }
    },
    //通知人内容
     getNotifiInfo(item) {
      if (isMeaningful(item)) {
         const array = item.map((e) => {
            return e.name;
         } );
         return array.toString();
      }else {
        return '-';
      }
     }

  }
}
</script>

<style lang="scss" scoped>
.op-title {
  font-size: 12px;
  line-height: 14px;
  color: #666666;
}
</style>